<script>
  import { get, call } from 'vuex-pathify'
  import screen from '@/helpers/screen'
  import IconEditUnderline from '@/images/icons/IconEditUnderline.svg'
  import IconSalePercent from '@/images/icons/IconSalePercent.svg'
  import IconOpenBox from '@/images/icons/IconOpenBox.svg'

  export default {
    components: {
      IconEditUnderline,
      IconOpenBox,
      IconSalePercent,
    },
    props: {
      orientation: {
        type: String,
        default: 'horizontal',
      },
      type: {
        type: String,
        default: '',
      },
      boxcode: {
        type: String,
        required: true,
      },
      boxtitle: {
        type: String,
        required: true,
      },
      boxdescription: {
        type: Array,
        default: () => [],
      },
      boxpopular: {
        type: Boolean,
      },
      boxbenefitssectiontitle: {
        type: String,
        default: '',
      },
      boxvalueprice: {
        type: String,
        default: '',
      },
      boxvaluecustomizablechoice: {
        type: Boolean,
      },
      boxvaluemembersmarketdeals: {
        type: Boolean,
      },
      boxbuttontextvverwrite: {
        type: String,
        default: '',
      },
      boxbuttoncolor: {
        type: String,
        default: '',
      },
      boxpriceheadertext: {
        type: String,
        default: '',
      },
      boxprice: {
        type: String,
        required: true,
      },
      boximage: {
        type: Object,
        required: true,
      },
      boxillustration: {
        type: Object,
        default: () => {},
      },
      boxcolor: {
        type: String,
        default: '',
      },
      checkorientation: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...get('prismic', ['getSubscribeBoxAndPlansData']),
      screen,
      boxCode() {
        return this.boxcode
      },
      boxTitle() {
        return this.boxtitle
      },
      boxDescription() {
        return this.boxdescription
      },
      boxPopular() {
        return this.boxpopular
      },
      boxBenefitsSectionTitle() {
        return this.boxbenefitssectiontitle
      },
      boxValuePrice() {
        return this.boxvalueprice
      },
      boxValueCustomizableChoice() {
        return this.boxvaluecustomizablechoice
      },
      boxValueMembersMarketDeals() {
        return this.boxvaluemembersmarketdeals
      },
      boxButtonTextOverwrite() {
        if (this.boxbuttontextvverwrite) {
          return this.boxbuttontextvverwrite
        }
        return 'Select this box'
      },
      boxButtonColor() {
        return this.boxbuttoncolor
      },
      boxPriceHeaderText() {
        if (this.boxpriceheadertext) {
          return this.boxpriceheadertext
        }
        return 'Starting At'
      },
      boxPrice() {
        return this.boxprice
      },
      boxImage() {
        return this.boximage
      },
      boxIllustration() {
        return this.boxillustration
      },
      boxColor() {
        return this.boxcolor
      },
      checkOrientation() {
        if (!this.screen.lg || this.checkorientation === 'vertical') {
          return true
        }
        return false
      },
    },
    created() {
      this.loadSubscriptionBoxandPlan()
    },
    methods: {
      ...call('prismic', ['loadSubscriptionBoxandPlan']),
    },
  }
</script>

<template>
  <!-- lg:col-start-2 is used as a work around as we needed to set the center item to the middle.  We may want to rework this to flexbox depending on what needs done -->
  <div
    :class="[
      'box-card-wrapper flex rounded-md h-full',
      checkOrientation
        ? 'flex-col-reverse text-center lg:col-start-2'
        : 'col-span-1 md:col-span-2 lg:col-span-3',
    ]"
  >
    <!-- <div
    :style="checkOrientation ? { width: 'calc((100% - 40px) / 3)' } : { }"
    :class="[
      'box-card-wrapper flex rounded-md h-full flex-1',
      checkOrientation ? 'flex-col-reverse text-center' : 'col-span-1 md:col-span-2 lg:col-span-3',
    ]"
  > -->
    <!-- flex flex-col-reverse -->
    <!-- <div :class="[`bg-${boxColor} flex-1`, checkOrientation ? 'p-6' : 'w-1/2 px-18 py-14']"> Note: Revert to this when we go back to 3 column for multi subs-->
    <div :class="[`bg-${boxColor} flex-1 h-full`, checkOrientation ? 'p-6' : 'w-1/2 px-12 py-12']">
      <!--Inner Content-->
      <div
        :class="[
          `bg-dawn px-6 pt-10 pb-6 relative rounded-md flex flex-col justify-between border-2`,
          checkOrientation ? 'border-black' : '',
        ]"
      >
        <div class="static">
          <div
            v-if="boxPopular === true"
            class="h-22 w-22 bg-sunshine flex rounded-full absolute top-0 right-0 transform translate-x-0 -translate-y-34 lg:translate-x-1/4 lg:-translate-y-1/4 z-10"
          >
            <div
              class="align-middle mx-auto my-auto text-center font-heading font-bold uppercase text-md leading-none"
            >
              Most
              <div class="text-sm pt-1">Popular</div>
            </div>
          </div>

          <!--Block Header-->
          <div
            :class="[
              'flex gap-4 border-b-1 pb-6 mb-6 border-primary border-opacity-25',
              checkOrientation ? 'flex-col' : '',
            ]"
          >
            <!-- <img
              v-if="boxIllustration"
              :class="[checkOrientation ? 'h-12 min-h-20' : 'min-w-28 w-42', 'object-contain']"
              :src="boxIllustration.url"
              :alt="boxIllustration.alt ? boxIllustration : 'Alltrue Product Illistration'"
            /> Note: Revert to this when we go back to 3 column for multi subs-->
            <img
              v-if="boxIllustration"
              :class="[checkOrientation ? 'h-12 min-h-20' : 'min-w-28', 'object-contain']"
              :src="boxIllustration.url"
              :alt="boxIllustration.alt ? boxIllustration : 'Alltrue Product Illistration'"
            />
            <div>
              <h2
                :class="['font-heading font-semibold', checkOrientation ? 'text-4xl' : 'text-6xl']"
                >{{ boxTitle }}</h2
              >
              <p class="font-medium">
                <PrismicRichText v-if="boxDescription" :field="boxDescription" />
              </p>
            </div>
          </div>

          <!--Block Content-->
          <div class="px-4 mb-8">
            <h3 class="uppercase font-semibold mb-2">{{ boxBenefitsSectionTitle }}</h3>
            <div :class="['flex justify-between', checkOrientation ? 'flex-col gap-4' : '']">
              <ul class="font-semibold">
                <li :class="['flex gap-1 align-middle', checkOrientation ? 'justify-center' : '']">
                  <IconOpenBox class="bullet-icon" /> <span>{{ boxValuePrice }}</span>
                </li>
                <li
                  v-if="boxValueCustomizableChoice === true"
                  :class="['flex gap-1 align-middle', checkOrientation ? 'justify-center' : '']"
                >
                  <IconEditUnderline class="bullet-icon" /> <span>Customizable choices</span>
                </li>
                <li
                  v-if="boxValueMembersMarketDeals === true"
                  :class="['flex gap-1 align-middle', checkOrientation ? 'justify-center' : '']"
                >
                  <IconSalePercent class="bullet-icon" /> <span>Member market deals</span>
                </li>
              </ul>
              <div class="text-center flex flex-col justify-end">
                <div class="uppercase font-semibold">{{ boxPriceHeaderText }}</div>
                <div class="font-heading font-semibold text-4xl leading-none mt-1">
                  ${{ boxPrice }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <!--Select Button-->
          <BaseButton :id="`button-${boxCode}`" :color="boxButtonColor" @click="$emit('selectBox')">
            {{ boxButtonTextOverwrite }}
          </BaseButton>
        </div>
      </div>
    </div>

    <!--Image-->
    <!-- <div :class="[checkOrientation ? '' : 'w-1/2']"> Note: Revert to this when we go back to 3 column for multi subs-->
    <div :style="!checkOrientation ? { width: '45%' } : {}">
      <img
        v-if="boxImage"
        class="object-cover h-full w-full"
        :src="boxImage.url"
        :alt="boxImage.alt ? boxImage.alt : 'Alltrue Subscription Box Image'"
      />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  /* purgecss start ignore */
  .cta-border-radius {
    border-bottom-left-radius: 0.4rem;

    @screen sm {
      border-bottom-right-radius: 0.4rem;
    }
  }

  .tshirt-front {
    @apply absolute hidden top-0 left-0 z-20;
  }

  .tshirt-image:hover .tshirt-front {
    @screen sm {
      @apply inline;
    }
  }

  .bullet-icon {
    width: 17px;
    height: 17px;
  }

  /* purgecss end ignore */
</style>
